<script setup lang="ts">
import organizationApi from '@/services/organization.service'
import { EStoreModules } from '@/store/storeType'
import {
    BaseDialog,
    FullScreenLoader,
    PrimaryButton,
    StackLayout,
    TypographyItem
} from '@rfc/rfc-components-library'
import { EAlertActions } from '@rfc/rfc-components-library/types'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'

const store = useStore()

type Props = {
    rentalId: number
}
const props = defineProps<Props>()
type Emits = {
    (e: 'refresh'): void
}
const emit = defineEmits<Emits>()

const { t } = useI18n()

const organizationId = computed(() => store?.state?.authentication.me?.organization_id)

const open = ref(false)
const loading = ref(false)

const confirmEndRental = () => {
    if (!organizationId.value) return
    loading.value = true
    organizationApi
        .endRental(organizationId.value, props.rentalId)
        .then(() => {
            open.value = false

            store?.dispatch(`${EStoreModules.ALERT}/${EAlertActions.QUEUE_ITEM}`, {
                action: EAlertActions.SUCCESS,
                message: t('device.rental.endRentalApiSuccess')
            })

            setTimeout(() => emit('refresh'), 5000)
        })
        .finally(() => (loading.value = false))
}
</script>

<template>
    <FullScreenLoader :loading="loading" />
    <PrimaryButton
        :label="$t('device.rental.endCurrentRentalAction')"
        @click="open = true"
        v-bind="$attrs" />
    <BaseDialog
        :title="$t('device.rental.endCurrentRentalTitle')"
        :open="open"
        @close="open = false"
        @confirm="confirmEndRental">
        <template #content>
            <StackLayout direction="column" :gap="16" class="w-full">
                <TypographyItem :label="$t('device.rental.endCurrentRentalDescription')" />
            </StackLayout>
        </template>
    </BaseDialog>
</template>
